import appConfig from '@configs/appConfig';
import getData from '@services/api/common/getData';
import { mailBoxes } from '@constants/appRoutes';

export const getMailBoxes = () => getData(appConfig.baseUrl.concat(mailBoxes));
